import moment from 'moment';
import { PartialValue } from '../use-update-tasks';

interface FilterFunctionArgs {
  record: Record<string, unknown>;
  updates: PartialValue[];
}

type FilterFunction = (request: FilterFunctionArgs) => boolean;

const and =
  <Args extends unknown, Fn extends (args: Args) => boolean>(
    ...filters: Fn[]
  ) =>
  (request: Args) =>
    filters.every((f) => f(request));

const canUpdateDueDate = ({ record, updates }: FilterFunctionArgs): boolean => {
  const [{ field, to: dueDate }] = updates;

  if (
    field.fieldName !== 'dueDate' ||
    dueDate == null ||
    record.startDate == null
  ) {
    return true;
  }

  return moment(dueDate as string).isSameOrAfter(
    moment(record.startDate as string),
  );
};

const canUpdateStartDate = ({
  record,
  updates,
}: FilterFunctionArgs): boolean => {
  const [{ field, to: startDate }] = updates;

  if (
    field.fieldName !== 'startDate' ||
    startDate == null ||
    record.dueDate == null
  ) {
    return true;
  }

  return moment(record.dueDate as string).isSameOrAfter(
    moment(startDate as string),
  );
};

export const canProceedToUpdate = and<FilterFunctionArgs, FilterFunction>(
  canUpdateDueDate,
  canUpdateStartDate,
);
